export default __webpack_public_path__ + "static/media/teleqLogo.dd531ddf.png";